// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__6ksAj","group":"Sidebar_group__Tm1cy","group-links":"Sidebar_group-links__IzInF","link":"Sidebar_link__2NQ_k"};